"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHome = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconHome = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M20.926 10.227c-.17.221-.32.26-.417.27-.328.026-.696-.233-.814-.338l-.04-.03-6.813-5.017a1.48 1.48 0 0 0-1.69.007l-6.846 5.04c-.117.104-.488.36-.815.337-.097-.01-.247-.048-.408-.257-.074-.104-.097-.195-.074-.304.078-.379.644-.826.95-1.013l7.776-5.836a.46.46 0 0 1 .535-.006l7.815 5.872c.262.157.829.604.907.983a.35.35 0 0 1-.066.292M18.5 20.998H15v-6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v6.5H5.5a.5.5 0 0 1-.5-.5v-9.61l6.735-4.955a.46.46 0 0 1 .524-.008l6.74 4.962v9.611a.5.5 0 0 1-.5.5m-8.5 0h4v-6h-4zM21.97 9.73c-.19-.91-1.252-1.566-1.328-1.607l-7.78-5.849a1.47 1.47 0 0 0-1.72.006L3.405 8.093c-.121.071-1.185.726-1.374 1.637-.081.384.003.762.25 1.104.299.391.688.618 1.125.658q.07.006.14.006c.16 0 .31-.033.455-.072v9.072c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-9.07c.187.051.385.083.596.064.436-.04.825-.267 1.133-.669.238-.33.322-.709.242-1.093" })] })));
};
exports.IconHome = IconHome;
exports.IconHome.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconHome;
